import { createContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { urlToggle } from "./DataContext";

export const LoginContext = createContext({});

export const LoginProvider = ({ children }) => {
  const [value, setValue] = useState({ user_id: "", user_pwd: "" });

  //로그인정보
  const [login, setLogin] = useState([]);
  //리프레시 정보
  const [refresh, setRefresh] = useState([]);

  const [adminChange, setAdminChange] = useState(false);
  const [suc, setSuc] = useState(false);

  const LoginSubmit = (e) => {
    e.preventDefault();
    axios.post("/odor/api/login", value).then((res) => {
      setLogin(res.data);
      setSuc(res.data.success);
    });
  };

  const url = "https://www.naju.go.kr/odor/declarelist/admin";
  const navigate = useNavigate();

  useEffect(() => {
    if (login?.success === true) {
      navigate("/odor/declarelist/admin");

      localStorage.setItem("login", login.data.auth_token.access_token);
      localStorage.setItem("refresh", login.data.auth_token.refresh_token);
    }
  }, [login]);

  //유저 리프레시 인증 토큰 발급
  const RefreshToken = async () => {
    const res = await axios.get(`${urlToggle}/odor/api/refresh`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        refresh_token: localStorage.getItem("refresh"),
      },
    });
    const refreshRes = res.data.result;
    setLogin(refreshRes);
  };

  useEffect(() => {
    if (localStorage.getItem("login") === null) {
      localStorage.setItem("login", refresh.access_token);
    }
  }, [refresh]);

  useEffect(() => {
    RefreshToken();
    const timer = setInterval(() => {
      RefreshToken();
    }, 600000);
    return () => clearInterval(timer);
  }, [suc]);

  return (
    <LoginContext.Provider
      value={{
        LoginSubmit,
        value,
        setValue,
        suc,
        setSuc,
        adminChange,
        setAdminChange,
        RefreshToken,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};
